import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { CallApiService } from './call.api.service';
import { CallEffects } from './call.effects';
import { callReducer, callInitialState, ICallState } from './call.reducer';
import { CallService } from './call.service';
import { callFeatureKey } from './types';

@NgModule({
  imports: [
    StoreModule.forFeature<ICallState>(callFeatureKey, callReducer, {
      initialState: callInitialState,
    }),
    EffectsModule.forFeature([CallEffects]),
  ],
  providers: [CallApiService, CallService],
})
export class StoreCallModule {}
